module.exports = __webpack_public_path__ + "static/media/galerija_2017 (10).32df77ed.jpg";